/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
  MessageHeader, Message,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
// import Results from "./Results.js";

// import MyCarousel from "./Carousel.js";
// import Video from './Video.js';
import YouTube from './YouTube.js';
// import overview from "./images/framework-crop-1.jpg";
// import teaser from './images/teaser.png';
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";
// import subsection_style_h3 from "./style.js";
// import MyCarousel from "./Carousel.js";
// import fig_noisy from './images/fig_noisy.jpg'
import './App.css'
// import variance from './images/variance.png'
import pipeline from './images/pipeline.png'
import video1 from './images/video1.mp4'
import video2 from './images/video2.mp4'
import video3 from './images/video3.mp4'
// import obj_normal from './images/obj_normal.png'
// import scene_normal from './images/scene_normal.png'
// import obj_depth from './images/obj_depth.png'
// import scene_depth from './images/scene_depth.png'


import LazyVideo from "./lazy-video";
// import result from './images/trimmed.mp4';
import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' 

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      SteinDreamer: Variance Reduction for Text-to-3D Score Distillation via Stein Identity
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const Authors = () => (      <Container text>
  {/* <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
  </Grid> */}
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}
    <a href="https://peihaowang.github.io//" target="_blank" rel="noreferrer">
    Peihao Wang<sup>1</sup>
    </a>
    <a href="https://zhiwenfan.github.io/" target="_blank" rel="noreferrer">
    Zhiwen Fan<sup>1</sup>
    </a>
    <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
      Dejia Xu<sup>1</sup>
    </a>
    <a href="https://wdilin.github.io/" target="_blank" rel="noreferrer">
    Dilin Wang<sup>2</sup>
    </a>
    <a href="https://sreyas-mohan.github.io/" target="_blank" rel="noreferrer">
    Sreyas Mohan<sup>2</sup>
    </a>
    <a href="http://forrestiandola.com/" target="_blank" rel="noreferrer">
    Forrest Iandola<sup>2</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
    Rakesh Ranjan<sup>2</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
    Yilei Li<sup>2</sup>
    </a>
    <a href="https://www.cs.utexas.edu/~lqiang/" target="_blank" rel="noreferrer">
    Qiang Liu<sup>1</sup>
    </a>
    <a
      href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
      target="_blank"
      rel="noreferrer"
    >
      Zhangyang Wang<sup>1</sup>
    </a>
    <a href="https://v-chandra.github.io/" target="_blank" rel="noreferrer">
    Vikas Chandra<sup>2</sup>
    </a>
    {/* </Grid.Column> */}
    {/* </Grid.Row> */}
  </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    <div>
      <sup>1</sup> The University of Texas at Austin, <sup>2</sup> Meta Reality Labs
    </div>
  {/* </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  > */}
    {/* <br /> */}
    {/* <div>*denotes equal contribution</div> */}
  </Grid>
  <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon>
              <a
                href="https://arxiv.org/abs/2401.00604"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon>
              <a
                href="https://github.com/Ir1d/SteinDreamer"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
</Container>
)

const mathStr1 = `We incorporate control variates constructed by Stein's identity into the score distillation and
derive Stein Score Distillation (SSD):

$$
\\mathbb{E}_{t, c, \\epsilon \\sim \\mathcal{N}(0, I)} \\left[\\omega(t) \\frac{\\partial x_t}{\\partial \\theta} \\left(\\nabla \\log p_t(x_t | y) + \\epsilon \\phi(t, x_t, \\theta, c) + \\nabla_x \\phi(t, x_t, \\theta, c) \\right) \\right]
$$

$$
x_t=\\alpha_t \\mathrm{NeRF}_{r g b}(\\theta, c)+\\sigma_t \\epsilon
$$

The control variate allows for arbitrary differnetiable baseline functions dependent on
timestep, NeRF parameters, noisy rendered image, and camera pose. For instance, we
implement the baseline function with an MiDAS depth estimator in this paper.

$$
\\phi(t, x_t, \\theta, c) = 1 - \\mathrm{PearsonCorr}(\\mathrm{NeRF}_{depth}(\\theta, c), \\text{MiDAS}(x_t))
$$
`

const mathStr2 = `
Score distillation essentially updates NeRF via a huge expectation:

$$
\\mathbb{E}_{t, c, \\epsilon \\sim \\mathcal{N}(0, I)} \\left[\\omega(t) \\frac{\\partial x_t}{\\partial \\theta} \\nabla \\log p_t(x_t | y) \\right]
$$

Evaluating this expectation via Monte-Carlo estimation suffers from high variance. This
motivates us to leverage control variate methods to reduce variance.

Wait, what is control variate method? Imagine you want to estimate $\\mathbb{E}[f(X)]$. You can instead estimate $\\mathbb{E}[f(X) + h(X)]$ in which $\\mathbb{E}[h(X)] = 0$ so that the mean is unchanged but the variance can be potentially reduced.

To construct a generic control variate, we find Stein identity can be an ideal tool. Here $\\phi(x)$ is called baseline function and can be literally any function.

$$
\\mathbb{E}_{x \\sim p} [\\nabla \\log p(x) \\phi(x) + \\nabla_x \\phi(x)] = 0
$$

By plugging Stein identity into the original expectation, we can easily obtain our SSD.
`

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Authors />

      <Container text style={{textAlign: "justify",}}>
      {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Overview
        </Header> */}
        {/* <MyCarousel mobile={mobile} ></MyCarousel> */}
        <p>
        <b>TL;DR:</b> We adopt control variate method constructed by Stein identity to reduce variance in Monte Carlo estimation for text-to-3D score distillation.
        </p>
        {/* <br></br> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
        Variance comparison between SDS and VSD
        </Header> */}
        {/* <Image src={variance} style={subsection_style} centered="true" ></Image>
        <p>
        We monitor the variance of SDS and VSD for every 100 training step. We show that variance level is highly correlated to the performance of score distillation.
        </p> */}
        {/* <br></br> */}
        {/* <Comparison /> */}
        {/* <Results /> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Visualizations
        </Header> */}
        {/* <MyCarousel mobile={mobile} /> */}
        {/* <Video /> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        Method Overview
        </Header>
        <Image src={pipeline} style={subsection_style} centered="true" ></Image>
        {/* <p>We incorporate control variates constructed by Stein's identity into the score distillation and
derive Stein Score Distillation (SSD):</p> */}
        <ReactMarkdown remarkPlugins={[remarkMath]}
            rehypePlugins={[rehypeKatex]} textAlign="center"
        >{mathStr1}</ReactMarkdown> 
        <Header as="h2" textAlign="center" style={subsection_style}>
        Results
        </Header>
        <Header as="h3" textAlign="center" style={{
            fontSize: "1.2em",
            fontWeight: "normal",
            marginBottom: "0.3em",
            marginTop: "0.8em",
            alignSelf: 'center',
        }}>
          SteinDreamer via MiDAS Depth
        </Header>
        <LazyVideo src={video1} no_control width="80%"></LazyVideo>
        <Header as="h3" textAlign="center" style={{
            fontSize: "1.2em",
            fontWeight: "normal",
            marginBottom: "0.3em",
            marginTop: "0.8em",
            alignSelf: 'center',
        }}>
          SteinDreamer via MiDAS Normal
        </Header>
        <LazyVideo src={video2} no_control width="80%"></LazyVideo>
        <Header as="h3" textAlign="center" style={{
            fontSize: "1.2em",
            fontWeight: "normal",
            marginBottom: "0.3em",
            marginTop: "0.8em",
            alignSelf: 'center',
        }}>
          SteinDreamer  for Scene Generatio
        </Header>
        <LazyVideo src={video3} no_control width="80%"></LazyVideo>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Rationale
        </Header>
        <ReactMarkdown remarkPlugins={[remarkMath]}
    rehypePlugins={[rehypeKatex]} textAlign="center"
>{mathStr2}</ReactMarkdown> 
        <p>Interestingly, SDS and VSD can be both interpreted as variance reduction techniques
using different control variates. See our  <a href="https://arxiv.org/abs/2401.00604" target="_blank"
                rel="noreferrer">paper</a> for more details.</p>
        {/* <Image src={fig_noisy} style={subsection_style}></Image> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If you want to cite our work, please kindly use:
          <pre>
            <code>
              {`@article{wang2023steindreamer,
  title={SteinDreamer: Variance Reduction for Text-to-3D Score Distillation via Stein Identity},
  author={Wang, Peihao and Fan, Zhiwen and Xu, Dejia and Wang, Dilin and Mohan, Sreyas and Iandola, Forrest and Ranjan, Rakesh and Li, Yilei and Liu, Qiang and Wang, Zhangyang and others},
  journal={arXiv preprint arXiv:2401.00604},
  year={2023}
}\}`}
            </code>
          </pre>
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Relevant Works
        </Header>
        <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/3D-Mode-Collapse/" target="_blank" rel="noreferrer">
    Taming Mode Collapse in Score Distillation for Text-to-3D Generation
    </a></MessageHeader>
    We derive an entropy-maximizing score distillation rule that fosters view diversity and address the multi-face problem for text-to-3D generation.
  </Message>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/4DGen/" target="_blank" rel="noreferrer">
    4DGen: Grounded 4D Content Generation with Spatial-temporal Consistency
    </a></MessageHeader>
    We introduce grounded 4D content generation. We identify static 3D assets and monocular video sequences as key components in constructing the 4D content. 
  </Message>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/NeuralLift-360/" target="_blank" rel="noreferrer">
    NeuralLift-360: Lifting An In-the-wild 2D Photo to A 3D Object with 360° Views
    </a></MessageHeader>
    We derive a prior distillation loss for CLIP-guided diffusion prior and utilize rough depth estimation in the wild with the help of a ranking loss.
  </Message>
        <br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
